import React from 'react';
import ActionDialog from '../../globalModals/ActionDialog';
import SupportForm from './SupportForm';
import { GlobalDialogProps } from '../../../types';

interface SupportFormDialogProps extends GlobalDialogProps {
  formSource?: string;
}

const SupportFormDialog: React.FC<SupportFormDialogProps> = ({
  onClose,
  formSource = 'Contact Support Dialog',
}) => (
  <ActionDialog
    title="Contact Support"
    open
    onClose={onClose}
    maxWidth="md"
    actions={[]}
  >
    <SupportForm formSource={formSource} />
  </ActionDialog>
);

export default SupportFormDialog;
